module.exports = __webpack_public_path__ + "img/okabe.1497145a.png";